
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/v1/header",
      function () {
        return require("private-next-pages/v1/header/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/v1/header"])
      });
    }
  